import * as React from "react";
import { Field } from "react-final-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
     PaperProps: {
          style: {
               maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
               width: 250,
          },
     },
};

const names = [
     "Oliver Hansen",
     "Van Henry",
     "April Tucker",
     "Ralph Hubbard",
     "Omar Alexander",
     "Carlos Abbott",
     "Miriam Wagner",
     "Bradley Wilkerson",
     "Virginia Andrews",
     "Kelly Snyder",
];

export default function UiMultipleSelect(props) {
     const [personName, setPersonName] = React.useState([]);
     const [valuesName, setValuesName] = React.useState([]);


     React.useEffect(() => {
          setPersonName([]);
     }, [props.value]);

     const handleChange = (event) => {
          
          const {
               target: { value },
          } = event;
          console.log(value.toString())
          setPersonName(
               // On autofill we get a stringified value.
               typeof value === "string" ? value.split(",") : value,
          );
          setValuesName(typeof value === "string" ? value.split(",") : value);
     };

     return (
        
                         <div>
                              <FormControl sx={{ width: "100%" }}>
                                   <InputLabel id="demo-multiple-checkbox-label">
                                        {props.label}
                                   </InputLabel>
                                   <Select
                                        labelId="demo-multiple-checkbox-label"
                                        id="demo-multiple-checkbox"
                                        multiple
                                        onChange={(e) => {
                                             handleChange(e);
                                             // input.onChange(e);
                                        }}
                                        input={
                                             <OutlinedInput
                                                  label={props.label}
                                             />
                                        }
                                        renderValue={(selected) =>
                                             selected.join(", ")
                                        }
                                        MenuProps={MenuProps}
                                        // {...input}
                                        value={personName}
                                   >
                                        {names.map((name) => (
                                             <MenuItem key={name} value={name}>
                                                  <Checkbox
                                                       checked={
                                                            personName.indexOf(
                                                                 name,
                                                            ) > -1
                                                       }
                                                  />
                                                  <ListItemText
                                                       primary={name}
                                                  />
                                             </MenuItem>
                                        ))}
                                   </Select>
                              </FormControl>
                              {props.multiplePrint && 
                              <span className="sba-multiple-print-text">{personName.join(", ")}</span>
                              }
                         </div>
                    );
              
}
